import { useState } from 'react';

interface DaySelectorNBProps {
  label?: string;
  value?: string[];
  onChange?: (days: string[]) => void;
}

const DAYS = [
  { label: 'Mon', code: 'mon' },
  { label: 'Tue', code: 'tue' },
  { label: 'Wed', code: 'wed' },
  { label: 'Thu', code: 'thu' },
  { label: 'Fri', code: 'fri' },
  { label: 'Sat', code: 'sat' },
  { label: 'Sun', code: 'sun' },
];

export default function DaySelectorNB({
  label,
  value = [],
  onChange,
}: DaySelectorNBProps) {
  const [selectedDays, setSelectedDays] = useState<string[]>(value);

  const handleDayClick = (code: string) => {
    let newDays: string[];
    if (selectedDays.includes(code)) {
      newDays = selectedDays.filter(d => d !== code);
    } else {
      newDays = [...selectedDays, code];
    }
    setSelectedDays(newDays);
    if (onChange) {
      onChange(newDays);
    }
  };

  const isSelected = (code: string) => selectedDays.includes(code);

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="font-nb font-bold text-sm text-nb-black">
          {label}
        </label>
      )}
      <div className="flex flex-wrap gap-2">
        {DAYS.map(day => (
          <button
            key={day.code}
            type="button"
            onClick={() => handleDayClick(day.code)}
            className={`
              px-3 py-2
              border-3 border-nb-black
              font-nb text-sm
              ${isSelected(day.code)
                ? 'bg-nb-black text-white'
                // sm:hover: keeps the desktop hover affordance but avoids the
                // "stuck yellow" state that plain `hover:` causes on mobile taps.
                : 'bg-nb-white text-nb-black sm:hover:bg-nb-yellow'
              }
            `.replace(/\s+/g, ' ').trim()}
          >
            {day.label}
          </button>
        ))}
      </div>
    </div>
  );
}